import { Divider } from 'component-library';
import { useTranslation } from 'react-i18next';

import { IndicatorName } from '@/api/rest/resources/types/fact';
import { GraphFact } from '@/components/Charts/types';
import { NCCard, NCCard2SectionLayout, NCCardComplianceFooter, NCCardHeader } from '@/components/NCCard/NCCard';
import { CanopyCoverExplainer } from '@/components/NCExplainers/CanopyCoverExplainer';
import { COMPLIANCE_LOGOS_CANOPY_COVER } from '@/config/constants';
import { usePlotFacts } from '@/pages/shared/hooks/usePlotFact';
import { getFactFromFactArray } from '@/pages/shared/hooks/utils';
import { isNullish } from '@/utils/booleans';

import { PlotCardWrapper } from '../PlotCardWrapper';
import { CanopyCoverGraphTile } from './GraphTile';
import { CanopyCoverCardStatsTile } from './StatsTile';

export const CanopyCover = () => {
  const { t } = useTranslation();

  return (
    <PlotCardWrapper name={t('shared.ncaDetail.details.forest.labels.canopyCover')}>
      <CanopyCoverPlotCard />
    </PlotCardWrapper>
  );
};

const CanopyCoverPlotCard = () => {
  const { t } = useTranslation();

  const factNames = {
    graph: IndicatorName.canopy_cover_pct_graph,
    latestAnalysis: IndicatorName.canopy_cover_pct,
  };

  const facts = usePlotFacts(Object.values(factNames));

  const graphData = getFactFromFactArray<GraphFact[]>(facts, factNames.graph)?.value;
  const latestFact = getFactFromFactArray<number>(facts, factNames.latestAnalysis);

  const hasChartData = !isNullish(graphData);
  const hasStatsData = !isNullish(latestFact?.value);

  if (!hasChartData && !hasStatsData) {
    return null;
  }

  return (
    <NCCard explainer={<CanopyCoverExplainer />}>
      <NCCardHeader
        title={t('shared.ncaDetail.details.forest.labels.canopyCover')}
        className='lg:grid-cols-[1fr_1fr]'
      />
      <NCCard2SectionLayout>
        <CanopyCoverGraphTile graphData={graphData} />
        <CanopyCoverCardStatsTile latestAnalysisFact={latestFact} />
      </NCCard2SectionLayout>
      <Divider />
      <NCCardComplianceFooter logos={COMPLIANCE_LOGOS_CANOPY_COVER} />
    </NCCard>
  );
};
